import styled from "styled-components";

export default styled.div`
  cursor: pointer;

  .c-tooltip {
    display: none;
  }

  &:hover .c-tooltip {
    display: block;
  }
`;
